import { useQuery } from "react-query";
import useAuthData from "../../auth/useAuthData";
import { NidComboboxMulti } from "../../components/ui-lib/Combobox";
import { Teacher } from "../../models/teacher/teacher";
import CreateExternalTeacherDialog, {
  ExternalTeacherFormFields,
} from "../../components/vacancy/CreateExternalTeacherDialog";
import { useState } from "react";
import { useTeachers } from "../../states/cache-state/useTeachers";

type VacancySubstituteSelectionComboboxProps = {
  onSetSubstitutes: (value: Teacher[] | undefined) => void;
  value?: Teacher[];
  placeholder?: string;
};

function VacancySubstituteSelectionCombobox({
  onSetSubstitutes,
  value,
  placeholder,
  ...props
}: VacancySubstituteSelectionComboboxProps) {
  const { currentSchool } = useAuthData();
  const { getTeachersOfSchool } = useTeachers();
  const { data: teachers } = useQuery(
    ["teachers", currentSchool?.id],
    () => getTeachersOfSchool(currentSchool!.id),
    {
      enabled: !!currentSchool,
    },
  );
  const [isCreateTeacherDialogOpen, setIsCreateTeacherDialogOpen] =
    useState(false);
  const [teacher, setTeacher] = useState<Partial<ExternalTeacherFormFields>>(
    {},
  );

  const onCreateTeacher = () => {
    setIsCreateTeacherDialogOpen(true);
  };

  const onCloseTeacherDialog = (teacher?: Teacher) => {
    setIsCreateTeacherDialogOpen(false);
    if (teacher) {
      onSetSubstitutes([...(value ?? []), teacher]);
    }
  };

  const onSetTeacherFromSearchText = (searchText: string) => {
    if (searchText) {
      const names = searchText.split(" ");
      setTeacher({
        name: names[0],
        lastname: names[1],
      });
    } else {
      setTeacher({});
    }
  };

  return (
    <>
      {teachers && (
        <NidComboboxMulti
          value={value}
          values={teachers}
          getDisplayText={(teacher) => `${teacher.name} ${teacher.lastname}`}
          getSearchText={(teacher) => `${teacher.name} ${teacher.lastname}`}
          onValueChange={onSetSubstitutes}
          compareBy={"email"}
          onSearchTextChanged={onSetTeacherFromSearchText}
          placeholder={placeholder}
          className={value?.length === 0 ? "border-th-primary-900" : undefined}
        >
          <NidComboboxMulti.OptionsPrefix>
            <button
              type="button"
              className="my-1 ml-auto mr-4 flex font-bold text-th-primary-900"
              onClick={onCreateTeacher}
            >
              {teacher?.name
                ? `${teacher.name} ${teacher.lastname ?? ""} erstellen`
                : "Externe Lehrperson erstellen"}
            </button>
          </NidComboboxMulti.OptionsPrefix>
        </NidComboboxMulti>
      )}
      {isCreateTeacherDialogOpen && (
        <CreateExternalTeacherDialog
          open={isCreateTeacherDialogOpen}
          onClose={onCloseTeacherDialog}
          teacher={teacher}
        />
      )}
    </>
  );
}

export default VacancySubstituteSelectionCombobox;
